<template>
  <div class="d-flex justify-content-center action-buttons-group">
    <!-- Lặp qua mảng actions được truyền từ component cha -->
    <template v-for="(action, index) in actionList">
      <!-- Nút có sử dụng router-link (Ví dụ: Sửa) -->
      <router-link
        v-if="action.isRouterLink"
        :key="`link-${index}`"
        :to="getRouterPath(action)"
        :title="action.text"
        class="me-1"
      >
        <ButtonCore
          :text="action.text"
          :variantClass="action.variantClass"
          :iconClass="action.iconClass"
          :customStyle="action.customStyle"
          :isDisable="action.isDisable"
        />
      </router-link>

      <!-- Nút gọi hàm (Ví dụ: Xem, Xóa) hoặc mở modal -->
      <ButtonCore
        v-else
        :key="`button-${index}`"
        :text="action.text"
        :variantClass="action.variantClass"
        :iconClass="action.iconClass"
        :handleClick="() => executeAction(action)"
        :modalTarget="action.modalTarget"
        :customStyle="action.customStyle"
        :isDisable="action.isDisable"
        class="me-1"
        :title="action.text"
      />
    </template>
  </div>
</template>

<script>
// Giả định bạn đã import ButtonCore đúng cách
// import { ButtonCore } from '@/components/widgets';
import ButtonCore from "./buttonCore.vue"; // Dùng đường dẫn tương đối cho ví dụ

export default {
  name: "ActionButtons",
  components: { ButtonCore },
  props: {
    // Đối tượng dữ liệu của hàng hiện tại
    item: {
      type: Object,
      required: true,
    },
    // Mảng các định nghĩa nút (Xem, Sửa, Xóa, ...)
    actions: {
      type: Array,
      required: true,
    },
  },
  computed: {
    // Tạo danh sách hành động hoàn chỉnh (nếu cần xử lý logic hiển thị)
    actionList() {
      // Có thể thêm logic ẩn/hiện nút dựa trên item.status ở đây
      return this.actions.filter((action) => {
        if (typeof action.shouldShow === "function") {
          return action.shouldShow(this.item);
        }
        return true;
      });
    },
  },
  methods: {
    // Hàm tạo đường dẫn router cho nút Sửa/router-link
    getRouterPath(action) {
      if (!action.basePath) {
        console.error("Action requires basePath for router-link:", action.type);
        return "#";
      }
      // Giả định tất cả router-link đều cần item._id
      return `${action.basePath}/${this.item._id}`;
    },

    // Hàm thực thi hành động (gọi hàm được truyền từ component cha qua sự kiện)
    executeAction(action) {
      if (action.type) {
        // Emit sự kiện với loại hành động và dữ liệu hàng/ID
        // Ví dụ: @view, @delete
        const payload = action.needsId ? this.item._id : this.item;
        this.$emit(action.type, payload);
      } else if (typeof action.handleClick === "function") {
        // Dùng hàm handleClick trực tiếp nếu không muốn emit
        action.handleClick(this.item);
      }
    },
  },
};
</script>

<style scoped>
.action-buttons-group {
  /* Đảm bảo khoảng cách giữa các nút */
  gap: 4px;
}
/* Style cho router-link wrapper */
.router-link {
  text-decoration: none;
}
</style>
